import axios from 'axios'
import { bffURL } from '../../config/endpoints'

const featureFlagAxios = axios.create()

const FETCH_FEATURE_FLAG = 'FETCH_FEATURE_FLAG'
const FETCH_FEATURE_FLAG_SUCCESS = 'FETCH_FEATURE_FLAG_SUCCESS'
const FETCH_FEATURE_FLAG_FAIL = 'FETCH_FEATURE_FLAG_FAIL'

export const initialState = {
  featureFlags: {},
  error: null,
  loading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FEATURE_FLAG:
      return {
        ...state,
        loading: true,
      }
    case FETCH_FEATURE_FLAG_SUCCESS:
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          [action.payload.name]: action.payload.status === 'A',
        },
        loading: false,
      }
    case FETCH_FEATURE_FLAG_FAIL:
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          // Intentional fail-open: if the feature flag API is unavailable we default the flag
          // to true so the cookie consent banner is still shown to users. This is the safer
          // choice — missing consent UX is worse than a brief API outage showing the banner.
          [action.meta]: true,
        },
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export const fetchFeatureFlag = (featureName) => (dispatch) => {
  dispatch({ type: FETCH_FEATURE_FLAG })
  return featureFlagAxios
    .get(`${bffURL}/adminfeature/name/${featureName}`)
    .then((resp) => {
      dispatch({ type: FETCH_FEATURE_FLAG_SUCCESS, payload: resp.data })
    })
    .catch((err) => {
      dispatch({ type: FETCH_FEATURE_FLAG_FAIL, payload: err, meta: featureName })
    })
}
